<template>
  <div class="px-4 pb-4 text-center">
    <b-form v-if="!showModalMessage" @submit="resetPassword()">
      <b-form-group>
        <b-input v-model="password" class="mb-2 mr-sm-2 mb-sm-0" placeholder="E-mail" />
        <img v-show="" class="input-correct" :src="'./static/img/' + $current_user.role +'/check_filled.png'">
      </b-form-group>
      <alert :success="alert.success" :error="alert.error"/>
      <b-button @click="resetPassword()" class="btn-neue" variant="none">
        <clip-loader :loading="processing" :color="'white'" :size="'17px'"></clip-loader>
        <span v-if="!processing">Senden</span>
      </b-button>
    </b-form>
    <div v-if="showModalMessage" class="text-center pb-3">
      Sie erhalten in Kürze eine E-Mail zum Zurücksetzen Ihres Passwortes.
    </div>
  </div>
</template>

<script>
// API
import pwdApi from '@/api/v1/pwd';
// Components
import Alert from '@/components/Helpers/Alert';
// mixins
import alert from '@/mixins/alert';

export default {
  components: { Alert },
  props: ['showModalMessage'],
  mixins: [alert],
  data() {
    return {
      password: '',
      processing: false,
      // showModalMessage: false,
      modalMessage: '',
    };
  },
  methods: {
    resetPassword() {
      this.processing = true;
      pwdApi.reset({ mail: this.password }).then((response) => {
        if (response.data.statuscode === 70) {
          this.processing = false;
          this.alert.error = 'Zu dieser E-Mail Adresse konnte kein Benutzer gefunden werden.';
          // this.alert.error = response.data.errormessage;
        } else {
          this.processing = false;
          this.showModalMessage = true;
          this.password = '';
        }
      });
    },
  },
  created() {
    this.showModalMessage = false;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Account/Reset.vue